import { Environment } from '@v2/environment/environment';
import { LiveAgentService } from './liveAgent/liveAgent';
import { OptimoveService } from './optimove/optimove-service';
import { SentryService } from './sentry/sentry';

export async function initializeThirdPartyShared(environment: Environment): Promise<void> {
  if (environment.environment === 'production' && environment.localServer === false) {
    import('./sentry/sentry').then(({ provideSentryService }: { provideSentryService: () => SentryService }) => {
      provideSentryService().init();
    });
    import('./optimove/optimove-service').then(
      ({ provideOptimoveService }: { provideOptimoveService: () => OptimoveService }) => {
        provideOptimoveService().init();
      }
    );

    const liveAgentLoaderElement: Element | null = document.querySelector('ec-live-agent-loader');
    if (liveAgentLoaderElement) {
      import('./liveAgent/liveAgent').then(
        ({ provideLiveAgentService }: { provideLiveAgentService: () => LiveAgentService }) => {
          provideLiveAgentService().init(liveAgentLoaderElement);
        }
      );
    }
  }
}
